import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  getPaidOrdersByStore(storeId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/stores/${storeId}?status=PAID`, httpOptions);
  }

  getOrdersInCheckingByStore(storeId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/stores/${storeId}?status=CHECKING`, httpOptions);
  }

  getOrdersInProcessByStore(storeId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/stores/${storeId}?status=PROCESSING`, httpOptions);
  }

  getOrderById(id) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/${id}`, httpOptions);
  }

  getAllOrdersByStoreId(storeId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/stores/${storeId}`, httpOptions);
  }

  getOrdersByDateByStoreId(storeId,dateStart,dateEnd) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/stores/${storeId}?initCreatedAt=${dateStart}&endCreatedAt=${dateEnd}`, httpOptions);
  }

  updateOrderStatusById(id, status) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.patch<any>(`${environment.url_api}/orders/${id}`, status, httpOptions);
  }

  validateOrderStatus(id, statusValidate, status){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.patch<any>(`${environment.url_api}/orders/${id}/validate/${statusValidate}/setStatus`, status, httpOptions);
  }

  updateOrderNote(id, note){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.patch<any>(`${environment.url_api}/orders/${id}`, note, httpOptions);
  }

  calculatePrices(customerId:number, storeId:number, products){
    let calculate = {"customerId": customerId,
    "storeId":storeId,
    "products":products}
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.post<any>(`${environment.url_api}/orders/products/calculate-prices`, calculate, httpOptions);
  }

  updateOrderPaymentMethod(id, paymnetMethods) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.post<any>(`${environment.url_api}/orders/${id}/orderPaymentMethods`, paymnetMethods, httpOptions);
  }


  veriryPaymentMovil(amount: any, phone: any,body){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.post<any>(`${environment.url_api}/bank-report/status/amount/${amount}/phone/${phone}`,body, httpOptions);
  }

  constructor(private http: HttpClient) { }
}
